import React from 'react';
import {
  InputAccessoryView,
  Keyboard,
  Platform,
  TouchableOpacity,
  View,
} from 'react-native';

import Text from '../Text';
import {tID} from '../../../utils/TestIdHelper';
import {useTheme, useThemedStyles} from '../../../theme';
import makeStyles from './styles';

/**
 * iOS "Done" bar above the keyboard for inputs whose keyboard has no return
 * key (number-pad, phone-pad). Pair with `inputAccessoryViewID={nativeID}` on
 * the TextInput. Renders nothing on Android/web (their keyboards dismiss via
 * the system back / enter key).
 */
const KeyboardDoneBar = ({nativeID}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  if (Platform.OS !== 'ios') {
    return null;
  }
  return (
    <InputAccessoryView nativeID={nativeID}>
      <View style={styles.bar}>
        <TouchableOpacity
          testID={tID('KeyboardDoneBar-Button-Done')}
          accessibilityRole="button"
          accessibilityLabel="Done"
          onPress={() => Keyboard.dismiss()}
          style={styles.doneButton}
        >
          <Text variation="Body1SemiBold" color={colors.accentStrong}>
            Done
          </Text>
        </TouchableOpacity>
      </View>
    </InputAccessoryView>
  );
};

export default KeyboardDoneBar;
